import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../components/button'
import { PageContainer } from '../../../../components/page-container/page-container'
import { paths } from '../../../../router/paths'
import { Input } from '../../../../components/input'

export const UserDetails = () => {
  const navigate = useNavigate()

  return (
    <PageContainer type="unauthenticated">
      <div className="flex w-full flex-col items-center gap-12 px-8">
        <div className="flex w-full flex-col gap-2 pt-8">
          <p className="pb-4 text-lg font-normal">Bienvenido a Dash</p>
          <div className="flex flex-col gap-8">
            <Input
              onChange={() => {}}
              value=""
              placeholder="Número de empleado"
            />
            <Input onChange={() => {}} value="" placeholder="Código de ruta" />
          </div>
        </div>
        <div className="flex w-full flex-col items-center pt-20">
          <Button
            className="h-[55px] w-full max-w-[196px] rounded-[10px] text-xl font-semibold"
            onClick={() => navigate(paths.home)}
          >
            Ingresar
          </Button>
        </div>
        <div className="flex w-full flex-col items-center pt-4">
          <Button
            variant="outlined"
            className="h-[55px] w-full max-w-[196px] rounded-[10px] text-xl font-semibold"
            onClick={() => navigate(paths.authentication.login)}
          >
            Regresar
          </Button>
        </div>
      </div>
    </PageContainer>
  )
}
